import { Xmark } from '@peacecover/icon';
import { useChangeCurrentCastRelationship } from '../hooks/useChangeCurrentCastRelationship';
import ProfileAvatar from '../../my-page/components/ProfileAvatar';
import type { components } from '../../../types/schema';

type CastRelationship = components['schemas']['ApiV1CastRelationship'];

interface PreviousCastRelationshipListProps {
  castRelationships: CastRelationship[];
  handleCreateCastRelationship: () => void;
}

const PreviousCastRelationshipList = ({
  castRelationships,
  handleCreateCastRelationship
}: PreviousCastRelationshipListProps) => {
  return (
    <div className="mt-[32px] flex flex-col items-center">
      <button
        type="button"
        className="py-[11px] bg-primary-light text-[14px] font-semibold leading-[17px] text-pure-white rounded-full px-[18px] min-w-[286px]"
        onClick={handleCreateCastRelationship}
      >
        새로운 조합으로 변경하기
      </button>
      <p className="text-[15px] font-semibold leading-[18px] text-main-dark-2 mt-[53px] mb-[20px]">
        이전에 봤던 조합
      </p>
      <div className="flex flex-col items-center gap-[10px] px-[24px] w-full">
        {castRelationships?.map((castRelationship) => (
          <PreviousCastRelationshipItem
            key={castRelationship.castRelationshipId}
            castRelationship={castRelationship}
          />
        ))}
      </div>
    </div>
  );
};

export default PreviousCastRelationshipList;

const PreviousCastRelationshipItem = ({
  castRelationship
}: {
  castRelationship: CastRelationship;
}) => {
 const { handleUpdateCastRelationship } = useChangeCurrentCastRelationship({
  castRelationshipId: castRelationship.castRelationshipId
});

  return (
    <div className="p-[20px] bg-backgroundElevated-dark rounded-[16px] border border-pure-black shadow-[0_0_2px_0_rgba(0,0,0,0.05),0_0_8px_0_rgba(0,0,0,0.07)] w-full flex items-center justify-between">
      <div className="flex items-center gap-[7px]">
        <div className="flex items-center gap-[4px]">
          <ProfileAvatar
            thumbnailUrl={castRelationship.personAThumbnailUrl}
            widthAndHeight="27px"
          />
          <p className="text-[12px] font-medium leading-[14px] text-main-dark-2">
            {castRelationship.personAName}
          </p>
        </div>
        <Xmark size={12} className="text-main-dark-3" />
        <div className="flex items-center gap-[4px]">
          <ProfileAvatar
            thumbnailUrl={castRelationship.personBThumbnailUrl}
            widthAndHeight="27px"
          />
          <p className="text-[12px] font-medium leading-[14px] text-main-dark-2">
            {castRelationship.personBName}
          </p>
        </div>
      </div>
      <button
        type="button"
        className="px-[12px] py-[6px] rounded-full bg-[rgba(255,255,255,0.10)] text-[13px] font-medium leading-[16px] text-onLabel-dark"
        onClick={handleUpdateCastRelationship}
      >
        선택
      </button>
    </div>
  );
};
